//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isApp, isWeiXin, system } from '@/util/const'
import CallUp from 'tool-callapp'

export default {
  props: {
    href: {
      type: String,
      default: window.location.href
    }
  },
  data () {
    return {
      isApp: Boolean(isApp()),
      isWeiXin: isWeiXin(),
      isIos: system(),
      openInBrowser: false
    }
  },
  mounted () {
    console.log(this.isApp)
  },
  methods: {
    callApp () {
      if (this.isWeiXin) {
        this.openInBrowser = true
        return
      }
      const _url = this.href
      const callup = new CallUp({
        // 协议头
        PROTOCAL: 'launchmylink',

        HOME: '',

        // 唤起失败时的跳转链接
        FAILBACK: {
          ANDROID: 'market://details?id=com.ChinaMobile',
          IOS: 'https://itunes.apple.com/hk/app/mylink-hk/id483513425?mt=8'
        },

        // Android apk 相关信息
        APK_INFO: {
          PKG: 'com.ChinaMobile',
          CATEGORY: 'android.intent.category.DEFAULT',
          ACTION: 'android.intent.action.VIEW'
        },

        // 唤起超时时间，超时则跳转到下载页面
        LOAD_WAITING: 3000
      })
      callup.loadSchema({
        targetURI: _url
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/component/uiShare.vue